import { apiRequest } from "./apiClient";

export const db = {};

export function collection(_db, name) { return { type: "collection", name }; }
export function doc(_db, collectionName, id) { return { type: "doc", collection: collectionName, id: String(id) }; }
export function where(field, operator, value) { return { type: "where", field, operator, value }; }
export function orderBy(field, direction = "asc") { return { type: "orderBy", field, direction }; }
export function limit(value) { return { type: "limit", value }; }
export function query(reference, ...constraints) { return { ...reference, constraints }; }

function applyConstraints(rows, constraints = []) {
  let result = [...rows];
  constraints.filter(c => c.type === "where").forEach(c => {
    result = result.filter(row => c.operator === "==" ? row[c.field] === c.value : true);
  });
  const sort = constraints.find(c => c.type === "orderBy");
  if (sort) result.sort((a, b) => {
    const left = a[sort.field] || "";
    const right = b[sort.field] || "";
    return (left > right ? 1 : left < right ? -1 : 0) * (sort.direction === "desc" ? -1 : 1);
  });
  const max = constraints.find(c => c.type === "limit");
  return max ? result.slice(0, max.value) : result;
}

function snapshot(data) {
  return { exists: () => Boolean(data), data: () => data || {}, id: data?.id };
}

export async function getDocs(reference) {
  const rows = await apiRequest(`/data/${encodeURIComponent(reference.name)}`);
  return { docs: applyConstraints(rows, reference.constraints).map(row => ({ id: row.id, data: () => { const copy = { ...row }; delete copy.id; return copy; } })), size: rows.length, empty: rows.length === 0 };
}

export async function getDocsFromServer(reference) { return getDocs(reference); }
export async function getDoc(reference) {
  try { return snapshot(await apiRequest(`/data/${encodeURIComponent(reference.collection)}/${encodeURIComponent(reference.id)}`)); }
  catch { return snapshot(null); }
}
export async function addDoc(reference, data) { return apiRequest(`/data/${encodeURIComponent(reference.name)}`, { method: "POST", body: JSON.stringify(data) }); }
export async function setDoc(reference, data) { return apiRequest(`/data/${encodeURIComponent(reference.collection)}/${encodeURIComponent(reference.id)}`, { method: "PUT", body: JSON.stringify(data) }); }
export async function updateDoc(reference, data) { return apiRequest(`/data/${encodeURIComponent(reference.collection)}/${encodeURIComponent(reference.id)}`, { method: "PATCH", body: JSON.stringify(data) }); }
export async function deleteDoc(reference) { return apiRequest(`/data/${encodeURIComponent(reference.collection)}/${encodeURIComponent(reference.id)}`, { method: "DELETE" }); }
export function serverTimestamp() { return new Date().toISOString(); }
export function writeBatch() {
  const writes = [];
  return {
    set(reference, data) { writes.push(setDoc(reference, data)); },
    update(reference, data) { writes.push(updateDoc(reference, data)); },
    delete(reference) { writes.push(deleteDoc(reference)); },
    commit() { return Promise.all(writes); },
  };
}